import PropTypes from "prop-types";
import React from "react";
import { connect, useSelector } from "react-redux";
// import { withRouter } from "react-router-dom"
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import QwikMedicSidebar from "./QwikMedicSidebar";
import QwikBistroSidebar from "./QwikBistroSidebar";

const Sidebar = props => {
  const currentCRM = useSelector(state => state?.user?.currentCRM);
  console.log("currentCRM", currentCRM);
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
